import React from "react";
import { Helmet } from 'react-helmet';
import { AuthProvider } from './contexts/AuthContext';
import { ProviderProvider } from './contexts/ProviderContext'; 
import Routes from "./Routes";
import { PhantomOrderSyncBridge } from './domains/orders/PhantomOrderSyncBridge';

function App() {
  return (
    <AuthProvider>
      {/* The title any page without its own goes back to. Only the sign-in
          and reset pages set one, and with nothing underneath, "Sign In -
          MealOps" stayed on every page after an in-app sign-in. */}
      <Helmet defaultTitle="MealOps" />
      <ProviderProvider>
        <PhantomOrderSyncBridge />
        <Routes />
      </ProviderProvider>
    </AuthProvider>
  );
}

export default App;
